// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"33924f1c","193":"ff3d8573","347":"33924f1c"}[chunkId] + ".chunk.css";
};